import axios from 'axios';
import { cmsURL } from '../config';

const API_BASE_URL = `${cmsURL}/api`;

export default class MasterCategoryService {

  static async fetchCategories() {
    try {
      const response = await axios.get(`${API_BASE_URL}/masterCategoryList`);
      const sortedData = response?.data?.sort?.((a, b) => b.masterCategoryId - a.masterCategoryId) || [];
      return sortedData;
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }
  }

  static async createCategory(formData) {
    try {
      const form = new FormData();

      form.append(
          'data',
          JSON.stringify({
            language_name: formData.language_name,
            product_id: formData.product_id,
            category_name: formData.category_name,
            category_text: formData.category_text,
            category_id: formData.category_id?.split(','),
            display_order: formData.display_order,
            adult: formData.adult ? 'yes' : 'no',

            carousel_cid: formData.carousel_cid
                ? formData.carousel_cid.split(',')
                : [],

            recent_video_cid: formData.recent_video_cid
                ? formData.recent_video_cid.split(',')
                : [],

            is_short: formData.is_short ? 1 : 0,

            shorts_cid_context_mapping: formData.is_short
                ? formData.shorts_cid_context_mapping
                : null,

            createdByUser: sessionStorage.getItem("userEmail"),
            status: 1,
          })
      );

      // Main category thumbnail is required
      form.append('cg_thumbnail', formData.cg_thumbnail);

      // Circular thumbnail is optional.
      // Only send it when Is Short is checked and a real file is selected.
      if (
          formData.is_short &&
          formData.circular_category_thumbnail instanceof File
      ) {
        form.append(
            'circular_category_thumbnail',
            formData.circular_category_thumbnail
        );
      }

      form.append(
          'emailId',
          sessionStorage.getItem("userEmail")
      );

      const response = await axios.post(
          `${API_BASE_URL}/createMasterCategory`,
          form,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
      );

      return response.data;

    } catch (error) {
      console.error('Error creating category:', error);
      console.error('Create API response:', error.response?.data);
      console.error('Create API status:', error.response?.status);
      throw error;
    }
  }

  static async updateCategory(categoryId, formData) {
    try {
      const fd = new FormData();

      // Normal text fields
      fd.append('masterCategoryId', categoryId);
      fd.append('category_text', formData.category_text || '');
      fd.append('emailId', sessionStorage.getItem("userEmail") || '');
      fd.append('display_order', formData.display_order || '');

      // Category IDs
      fd.append(
          'category_id',
          JSON.stringify(
              formData.category_id
                  ? formData.category_id.split(',').map(id => id.trim()).filter(Boolean)
                  : []
          )
      );

      // Carousel CIDs
      fd.append(
          'carousel_cid',
          JSON.stringify(
              formData.carousel_cid
                  ? formData.carousel_cid.split(',').map(id => id.trim()).filter(Boolean)
                  : []
          )
      );

      // Recent Video CIDs
      fd.append(
          'recent_video_cid',
          JSON.stringify(
              formData.recent_video_cid
                  ? formData.recent_video_cid.split(',').map(id => id.trim()).filter(Boolean)
                  : []
          )
      );

      // Is Short
      fd.append(
          'is_short',
          formData.is_short ? '1' : '0'
      );

      // Shorts CID Context Mapping
      fd.append(
          'shorts_cid_context_mapping',
          formData.shorts_cid_context_mapping ?? ''
      );

      // Adult
      fd.append(
          'adult',
          formData.adult ? 'yes' : 'no'
      );

      // IMPORTANT:
      // Only send cg_thumbnail when user selected a NEW file.
      // Existing thumbnail is only a URL string and must NOT be sent.
      if (formData.cg_thumbnail instanceof File) {
        fd.append(
            'cg_thumbnail',
            formData.cg_thumbnail
        );
      }

      // IMPORTANT:
      // Only send circular thumbnail when user selected a NEW file.
      // Existing circular thumbnail is a URL string and must NOT be sent.
      if (
          formData.is_short &&
          formData.circular_category_thumbnail instanceof File
      ) {
        fd.append(
            'circular_category_thumbnail',
            formData.circular_category_thumbnail
        );
      }

      console.log("Update Category FormData", {
        masterCategoryId: categoryId,
        category_text: formData.category_text,
        category_id: formData.category_id,
        carousel_cid: formData.carousel_cid,
        recent_video_cid: formData.recent_video_cid,
        is_short: formData.is_short,
        shorts_cid_context_mapping:
        formData.shorts_cid_context_mapping,
        cg_thumbnail: formData.cg_thumbnail,
        circular_category_thumbnail:
        formData.circular_category_thumbnail
      });

      const response = await axios.post(
          `${API_BASE_URL}/editMasterCategory`,
          fd,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
      );

      return response.data;

    } catch (error) {
      console.error('Error updating category:', error);
      console.error(
          'Update API response:',
          error.response?.data
      );
      console.error(
          'Update API status:',
          error.response?.status
      );
      throw error;
    }
  }

  static async pushToProd(categoryId, productId, languageName) {
    try {
      const response = await axios.post(`${API_BASE_URL}/pushToProd`, {
        masterCategoryId: categoryId,
        productId: productId,
        languageName: languageName
      });
      return response.data;
    } catch (error) {
      console.error('Error pushing category to production:', error);
      throw error;
    }
  }

  static async deleteCategory(categoryId, emailId) {
    try {
      const response = await axios.delete(`${API_BASE_URL}`, {
        params: {
          id: categoryId,
          emailId: emailId
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error deleting category:', error);
      throw error;
    }
  }
}
